import PropTypes from 'prop-types'
import React, { useState, useEffect, useRef } from "react"
import {
    Row,
    Col,
    Card,
    Alert,
    CardBody,
    Button,
    Modal,
    ModalBody
} from "reactstrap";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility'

import avatar from "../../assets/images/companies/img-4.png"
// actions
import { createCompany, companySuccess, companyError, updateCompany } from "../../store/actions";
import { profileSuccess, getProfile } from '../../store/auth/profile/actions';
import { post, upload, put } from '../../helpers/api_helper';
import { toast } from 'react-toastify';
import SearchableDropdown from '../../components/SearchableDropDown';
import countryJson from '../../assets/jsons/country.json';
import stateJson from '../../assets/jsons/state.json';
import cityJson from '../../assets/jsons/city.json';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
// import Resizer from "react-image-file-resizer";

const Company = props => {
    const { user, data, setLoading } = props;
    const [descLength, setDescLength] = useState(0);
    const [companyName, setCompanyName] = useState("");
    const [copied, setCopied] = useState(false);
    const [file, setFile] = useState(null);
    const [imageToCrop, setImageToCrop] = useState(null);
    const imageInput = useRef();
    const cropper = useRef();
    const [isCroping, setIsCroping] = useState(false);

    async function handleValidSubmit(event, values) {
        let image = "";
        if (file.length > 85) {
            const fileObj = await urltoFile(file, (new Date().getTime() + 300) + '.webp', 'image/webp')
            const form = new FormData();
            form.append("image", fileObj);
            const uploadedBanner = await upload("/comp/image_upload", form)
            // console.log('response from image upload', uploadedBanner);
            if(uploadedBanner?.statusCode==200)
                image = uploadedBanner?.data;
        } else
            image = file;
        // console.log('image to update', image);
        // return;
        // if(file?.length)
        if (data) {
            const body = {
                ...values,
                logo: image,
                companyId: data?._id,
                token: user?.token,
            }
            let url = "/comp/update";
            setLoading(true);
            put(url, body)
                .then((json) => {
                    console.log('response from updating comp', json);
                    setLoading(false);
                    if (json.statusCode == 200) {
                        console.log('company updated');
                        toast.success(json?.message);
                        props.close(false);
                    } else {
                        toast.error(json?.error);
                    }
                })
                .catch(error => {
                    console.error('error while updating company', error);
                    toast.error(JSON.stringify(error));
                    setLoading(false);
                })
        } else {
            const body = {
                ...values,
                logo: image,
                addedBy: user?._id,
                token: user?.token,
            }
            let url = "/comp/add";
            setLoading(true);
            post(url, body)
                .then((json) => {
                    console.log('response from adding comp', json);
                    setLoading(false);
                    if (json.statusCode == 200) {
                        console.log('oppor added');
                        toast.success(json?.message);
                        props.close(false);
                    } else {
                        toast.error(json?.error);
                    }
                })
                .catch(error => {
                    console.error('error while adding oppor', error);
                    toast.error(JSON.stringify(error));
                    setLoading(false);
                })
        }
    }

    useEffect(()=>{
        if(data?.logo)
            setFile(data?.logo);
    }, [data]);

    useEffect(() => {
        if (data) {
            console.log('user on company', data);
            setCompanyName(data?.title)
        }
    }, [user]);

    const uploadImage = (e) => {
        console.log('onchange image input', e.target.files[0]);
        var file = e.target.files[0];
        if (file) {
            const form = new FormData();
            form.append("file", file);
            upload('/user/upload', form, user?.token)
                .then(json => {
                    console.log('response from upload', json);
                })
                .catch(error => {
                    console.log('error on upload method', error);
                })
        }
    }

    const onChangeFile = (e) => {
        console.log('getting event on input img', e.target.files[0]);
        setImageToCrop(URL.createObjectURL(e.target.files[0]));
        // setImageChanged(true);
        setIsCroping(true);
    }

    const urltoFile = (url, filename, mimeType) => {
        return (fetch(url)
            .then(function (res) { return res.arrayBuffer(); })
            .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
        );
    }

    const crop = async () => {
        const fileData = cropper?.current?.cropper?.getCroppedCanvas().toDataURL();
        setIsCroping(false);
        setFile(fileData);
    }

    // const resizeFile = (file) =>
    //     new Promise((resolve) => {
    //         Resizer.imageFileResizer(
    //             file,
    //             1800,
    //             600,
    //             "webp",
    //             60,
    //             0,
    //             (uri) => {
    //                 resolve(uri);
    //             },
    //             "file"
    //         );
    //     });


    return (
        <React.Fragment>
            <div>
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex">
                                    <div className="me-3 position-relative">
                                        <img
                                            src={file ? file : avatar}
                                            alt=""
                                            className="avatar-md rounded-circle img-thumbnail"
                                            onClick={(e) => imageInput.current.click(e)}
                                        />
                                        <div style={{ position: 'absolute', height: 25, width: 25, right: 3, bottom: 3, backgroundColor: Utils.themeColor, borderRadius: 50, textAlignLast: 'center', cursor: 'pointer' }}
                                            onClick={(e) => imageInput.current.click(e)}
                                        >
                                            <i className="mdi mdi-camera-outline" style={{ color: 'white', verticalAlign: 'text-top', fontSize: 15 }} />
                                        </div>
                                        <input type="file" id="file"
                                            ref={imageInput}
                                            onChange={onChangeFile}
                                            style={{ display: "none" }} />
                                    </div>
                                    <div className="align-self-center">
                                        <div className="text-muted">
                                            <h5>{companyName}</h5>
                                            <p className="mb-1">ID: {data?.compId ? data?.compId : 'AP****'}
                                                <Button onClick={(e) => { navigator.clipboard.writeText(data?.compId); setCopied(true) }}
                                                    title={"Copy"}
                                                    style={{ backgroundColor: Utils.themeColor, marginLeft: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-content-copy" style={{ fontSize: 20 }}></span></Button>
                                                {copied &&
                                                    <span style={{ color: 'green' }}>Copied!</span>
                                                }</p>
                                        </div>
                                    </div>
                                    <div className="text-center" style={{ marginLeft: 'auto' }}>
                                        <Button color="primary" onClick={() => { props.setCurrentUser(null); props?.close(false) }} style={{ backgroundColor: Utils.themeColor }}>
                                            Close
                                        </Button>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal className="modal_form" isOpen={isCroping} toggle={() => { setIsCroping(false); setFile(null) }} centered={true}>
                    <ModalBody className="py-3 px-5">
                        <Cropper
                            style={{ height: 'auto', width: 400 }}
                            aspectRatio={1 / 1}
                            preview=".img-preview"
                            guides={true}
                            src={imageToCrop}
                            ref={cropper}
                        />
                        <Row className='mt-4'>
                            <Col md={6}>
                                <button
                                    className="btn btn-primary w-100 waves-effect waves-light"
                                    style={{ backgroundColor: Utils.themeColor }}
                                    onClick={() => { setIsCroping(false); setFile(null) }}
                                    type="reset"
                                >
                                    Cancel
                                </button>
                            </Col>
                            <Col md={6}>
                                <button
                                    className="btn btn-primary w-100 waves-effect waves-light"
                                    onClick={crop}
                                    style={{ backgroundColor: Utils.themeColor }}
                                >
                                    Crop
                                </button>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <h4 className="card-title mb-4">{data ? 'Update Company Details' : 'Create A Company'}</h4>

                <Card>
                    <CardBody>
                        <AvForm
                            className="form-horizontal"
                            onValidSubmit={(e, v) => {
                                handleValidSubmit(e, v)
                            }}
                        >
                            <Row>
                                <Col md={6}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="title"
                                            label="Name"
                                            value={data?.title}
                                            className="form-control"
                                            placeholder="Enter Name"
                                            type="text"
                                            required
                                            onChange={(e) => setCompanyName(e.target.value)}
                                        />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="code"
                                            label="Company Code"
                                            value={data?.code}
                                            className="form-control"
                                            placeholder="Enter Company Code"
                                            type="text"
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="type"
                                            label="Company Type"
                                            value={data?.type}
                                            className="form-control"
                                            placeholder="Enter Company Type"
                                            type="select"
                                            required
                                            validate={{ async: (v, c, i, cb) => { cb(v != "-" || v == "") } }}
                                        >
                                            <option value="-">Select Company Type</option>
                                            <option value="Private Limited Company">Private Limited Company</option>
                                            <option value="Public Limited Company">Public Limited Company</option>
                                            <option value="Partnerships Company">Partnerships Company</option>
                                            <option value="Limited Liability Partnership">Limited Liability Partnership</option>
                                            <option value="One Person Company">One Person Company</option>
                                            <option value="Sole Proprietorship">Sole Proprietorship</option>
                                            <option value="Section 8 Company">Section 8 Company</option>
                                        </AvField>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="strength"
                                            label="Company Strength"
                                            value={data?.strength}
                                            className="form-control"
                                            placeholder="Enter Company Strength"
                                            type="number"
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="operatingState"
                                            label="Company Operating State"
                                            value={data?.operatingState}
                                            className="form-control"
                                            placeholder="Enter Number of state"
                                            type="number"
                                            required
                                            validate={{ min: { value: 1 } }}
                                        />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group mb-4">
                                        <AvField
                                            name="workingDay"
                                            label="Company Working Day"
                                            value={data?.workingDay}
                                            className="form-control"
                                            placeholder="Enter Company Working Day"
                                            type="number"
                                            required
                                            validate={{ min: { value: 1 }, max: { value: 7 } }}
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <div className="form-group">
                                <AvField
                                    name="desc"
                                    label="Description"
                                    value={data?.desc}
                                    className="form-control"
                                    placeholder="Enter Description"
                                    type="textarea"
                                    required
                                    validate={{ maxLength: { value: 300 } }}
                                    onChange={(t) => setDescLength(t.target.value.length)}
                                />
                            </div>
                            <div className="mt-3" style={{ textAlign: 'end' }}>
                                <p>{descLength}/300</p>
                            </div>

                            {/* <AvField name="idx" value={user?.company._id} type="hidden" /> */}
                            <div className="text-center mt-4">
                                {data ?
                                    <Button type="submit" color={"primary"} style={{ backgroundColor: Utils.themeColor }}>
                                        Update Company
                                    </Button>
                                    :
                                    <Button type="submit" color="danger">
                                        Create Company
                                    </Button>
                                }
                            </div>
                        </AvForm>
                    </CardBody>
                </Card>
            </div>
        </React.Fragment>
    )
}

Company.propTypes = {
    getProfile: PropTypes.func,
    error: PropTypes.any,
    success: PropTypes.any,
    companyError: PropTypes.func,
    companySuccess: PropTypes.func,
    createCompany: PropTypes.func,
    updateCompany: PropTypes.func
}

const mapStatetoProps = state => {
    const { user } = state.Profile;
    const { error, success, company } = state.Company;
    return { error, success, user, company }
}

export default withRouter(
    connect(mapStatetoProps, { createCompany, companySuccess, companyError, getProfile, updateCompany })(Company)
)
